import {Typography, useTheme} from "@mui/material";

const RequiredFields = () => {
  const theme = useTheme();

  return (
    <Typography className="form-text" sx={{ fontWeight: 600, mt: '15px', mb: '15px' }}>
      Fields marked with an asterisk (<span style={{ color: theme.palette.red.main }}>*</span>) are required.
    </Typography>
  );
    }

export default RequiredFields;
